export const HEADER_NAV_ITEMS = [
  { labelKey: 'header.navigation.movies', link: '/movies' },
  { labelKey: 'header.navigation.tvShows', link: '/tvshows' },
  { labelKey: 'header.navigation.liveTv', link: '/livetv' },
  { labelKey: 'header.navigation.sportsVod', link: '/sports' },
  { labelKey: 'header.navigation.sportLiveTv', link: '/sport-live-tv' },
  { labelKey: 'header.navigation.tvGuide', link: '/tvguide' },
  { labelKey: 'header.navigation.search', link: '/search' },
  { labelKey: 'header.navigation.myList', link: '/mylist' },
];
